import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { LightboxProvider } from './context/LightboxContext';
import ImageLightboxModal from './components/common/ImageLightboxModal';
import FloatingWidgets from './components/common/FloatingWidgets';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import InstallmentPage from './pages/InstallmentPage';
import CashPage from './pages/CashPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import WishlistPage from './pages/WishlistPage';
import CartPage from './pages/CartPage';
import FaqPage from './pages/FaqPage';
import ShippingPolicyPage from './pages/ShippingPolicyPage';
import ReturnsPage from './pages/ReturnsPage';
import WarrantyPage from './pages/WarrantyPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ShowroomDashboardPage from './pages/ShowroomDashboardPage';
import AddToCartAnimationModal from './components/cart/AddToCartAnimationModal';
import WishlistAnimationModal from './components/cart/WishlistAnimationModal';

function AppLayout() {
    return (
        <LightboxProvider>
            <div className="app">
                <Header />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/products" element={<ProductsPage />} />
                        <Route path="/products/:id" element={<ProductDetailPage />} />
                        <Route path="/installment" element={<InstallmentPage />} />
                        <Route path="/cash" element={<CashPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/dashboard" element={<ShowroomDashboardPage />} />
                        <Route path="/portal" element={<ShowroomDashboardPage />} />
                        <Route path="/blogs" element={<BlogListPage />} />
                        <Route path="/blog" element={<BlogListPage />} />
                        <Route path="/blogs/:slug" element={<BlogDetailPage />} />
                        <Route path="/blog/:slug" element={<BlogDetailPage />} />
                        <Route path="/wishlist" element={<WishlistPage />} />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/shipping" element={<ShippingPolicyPage />} />
                        <Route path="/returns" element={<ReturnsPage />} />
                        <Route path="/warranty" element={<WarrantyPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingWidgets />
                <ImageLightboxModal />
                <AddToCartAnimationModal />
                <WishlistAnimationModal />
                <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
            </div>
        </LightboxProvider>
    );
}

export default AppLayout;
